import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";

import { useStyles } from "./CustomDialogBox.css";

class CustomDialogBox extends Component {
  render() {
    const { classes, question, description } = this.props;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleClose}
        className={classes.root}
        classes={{
          paper: classes.paper,
        }}
      >
        <DialogTitle>
          {question ? question : "Are you sure you want to delete this data?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {description
              ? description
              : "This will delete the data permanently. Select Delete to delete or Cancel to cancel"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            aria-label="Cancel"
            variant="contained"
            disableRipple
            className={classes.cancelButtonStyle}
            onClick={this.props.handleClose}
          >
            Cancel
          </Button>
          <Button
            aria-label="Delete"
            disableRipple
            className={classes.deleteButtonStyle}
            onClick={this.props.handleDelete}
          >
            {this.props.buttonLabel ? this.props.buttonLabel : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(useStyles)(CustomDialogBox);
